import { c as _c } from "react/compiler-runtime";
import { useFetchGetSitePresetQuery } from '@module/queries/preset/presetQueryHooks';
import useLiveSortStore from '@module/stores/useLiveSortStore';
import { useEffect } from 'react';
import { getDefaultLiveSortType, getLiveSortByType } from './getResolvedLiveSort';
const useLiveSortState = () => {
  const $ = _c(13);
  const {
    data: sitePreset
  } = useFetchGetSitePresetQuery();
  const selectedSortType = useLiveSortStore(_temp);
  const setSelectedSortType = useLiveSortStore(_temp2);
  const syncSelectedSortTypeFromSearch = useLiveSortStore(_temp3);
  let t0;
  let t1;
  if ($[0] !== syncSelectedSortTypeFromSearch) {
    t0 = () => {
      syncSelectedSortTypeFromSearch(window.location.search);
    };
    t1 = [syncSelectedSortTypeFromSearch];
    $[0] = syncSelectedSortTypeFromSearch;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== selectedSortType || $[4] !== sitePreset?.preset?.liveSortValue) {
    t2 = selectedSortType ?? getDefaultLiveSortType(sitePreset?.preset?.liveSortValue ?? "user");
    $[3] = selectedSortType;
    $[4] = sitePreset?.preset?.liveSortValue;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const sortType = t2;
  let t3;
  if ($[6] !== sortType) {
    t3 = getLiveSortByType(sortType);
    $[6] = sortType;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const {
    onlyNewBj,
    orderBy
  } = t3;
  let t4;
  if ($[8] !== onlyNewBj || $[9] !== orderBy || $[10] !== setSelectedSortType || $[11] !== sortType) {
    t4 = {
      sortType,
      onlyNewBj,
      orderBy,
      setSelectedSortType
    };
    $[8] = onlyNewBj;
    $[9] = orderBy;
    $[10] = setSelectedSortType;
    $[11] = sortType;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};
export default useLiveSortState;
function _temp(state) {
  return state.selectedSortType;
}
function _temp2(state_0) {
  return state_0.setSelectedSortType;
}
function _temp3(state_1) {
  return state_1.syncSelectedSortTypeFromSearch;
}